import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=54211bbf&scoped=true&"
import script from "./Model.vue?vue&type=script&lang=js&"
export * from "./Model.vue?vue&type=script&lang=js&"
import style0 from "./Model.vue?vue&type=style&index=0&id=54211bbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54211bbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54211bbf')) {
      api.createRecord('54211bbf', component.options)
    } else {
      api.reload('54211bbf', component.options)
    }
    module.hot.accept("./Model.vue?vue&type=template&id=54211bbf&scoped=true&", function () {
      api.rerender('54211bbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/device/components/Model.vue"
export default component.exports